@if (images().length > 0) {
	<vp-carousel-modal [images]="images()" class="block">
		<div
			class="lg:h-112 lg:grid-cols-20 grid h-80 grid-cols-6 grid-rows-6 gap-1 sm:h-96 sm:grid-cols-4 sm:grid-rows-4"
			data-test-id="image-grid"
		>
			@switch (visibleImages().length) {
				@case (1) {
					<ng-container [ngTemplateOutlet]="oneImage" />
				}
				@case (2) {
					<ng-container [ngTemplateOutlet]="twoImages" />
				}
				@case (3) {
					<ng-container [ngTemplateOutlet]="threeImages" />
				}
				@case (4) {
					<ng-container [ngTemplateOutlet]="fourImages" />
				}
			}
		</div>
	</vp-carousel-modal>
}

<ng-template #oneImage>
	<vp-image-grid-cell
		[height]="448"
		[image]="visibleImages()[0]"
		[overlayCount]="overlayCount()"
		[width]="1280"
		class="lg:col-span-20 col-span-6 row-span-6 sm:col-span-4 sm:row-span-4"
	/>
</ng-template>

<ng-template #twoImages>
	<vp-image-grid-cell
		[height]="448"
		[image]="visibleImages()[0]"
		[width]="766"
		class="col-span-6 row-span-3 sm:col-span-2 sm:row-span-4 lg:col-span-12"
	/>
	<vp-image-grid-cell
		[height]="448"
		[image]="visibleImages()[1]"
		[overlayCount]="overlayCount()"
		[width]="510"
		class="col-span-6 row-span-3 sm:col-span-2 sm:row-span-4 lg:col-span-8"
	/>
</ng-template>

<ng-template #threeImages>
	<vp-image-grid-cell
		[height]="448"
		[image]="visibleImages()[0]"
		[width]="766"
		class="col-span-6 row-span-4 sm:col-span-2 lg:col-span-12"
	/>
	<vp-image-grid-cell
		[height]="222"
		[image]="visibleImages()[1]"
		[width]="510"
		class="col-span-3 row-span-2 sm:col-span-2 lg:col-span-8"
	/>
	<vp-image-grid-cell
		[height]="222"
		[image]="visibleImages()[2]"
		[overlayCount]="overlayCount()"
		[width]="510"
		class="col-span-3 row-span-2 sm:col-span-2 lg:col-span-8"
	/>
</ng-template>

<ng-template #fourImages>
	<vp-image-grid-cell
		[height]="448"
		[image]="visibleImages()[0]"
		[width]="766"
		class="col-span-6 row-span-4 sm:col-span-2 lg:col-span-12"
	/>
	<vp-image-grid-cell
		[height]="222"
		[image]="visibleImages()[1]"
		[width]="510"
		class="col-span-2 row-span-2 sm:col-span-2 lg:col-span-8"
	/>
	<vp-image-grid-cell
		[height]="222"
		[image]="visibleImages()[2]"
		[width]="253"
		class="col-span-2 row-span-2 sm:col-span-1 lg:col-span-4"
	/>
	<vp-image-grid-cell
		[height]="222"
		[image]="visibleImages()[3]"
		[overlayCount]="overlayCount()"
		[width]="253"
		class="col-span-2 row-span-2 sm:col-span-1 lg:col-span-4"
	/>
</ng-template>
